import { render, staticRenderFns } from "./Rechtssammlung.vue?vue&type=template&id=5f0c70d1&scoped=true&"
import script from "./Rechtssammlung.vue?vue&type=script&lang=js&"
export * from "./Rechtssammlung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c70d1",
  null
  
)

export default component.exports